import React, { useState, useEffect, useRef } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";

import { ToastContainer } from "react-toastify";

import { interestLevel } from "../../../Enum";
import { FaChevronDown } from "react-icons/fa";
import Select, { components } from "react-select";

import teamService from "../../Services/TeamService";
import leadSourceService from "../../Services/LeadSourceService";

import LeadTable from "../../Form/LeadTable/LeadTable";
import LeadDbService from "../../Services/LeadDbService";
import AssignLeadFilter from "./AssignLeadFilter";
import { useLocation, useNavigate } from "react-router-dom";
import { showErrorToast, showInfoToast } from "../../Constant/Notification";
import { teamIds } from "../../../utils/storage";

import CustomHeading from "../../common/CustomHeading";
import { getBasePathByUserRole } from "../../../utils/roleRoutes";
import CustomButton from "../../common/CustomButton";
import AssignModel from "./AssignModel";
import CustomModel from "../../common/CustomModel";
import CustomTruncatedText from "../../common/CustomTruncatedText";
import CustomSelect from "../../common/CustomSelect";
import { formatToIndianDate } from "../../../utils/dateFormatter";
import { status } from "../../../Enum/LeadEnumConstants";

const AssignMain = () => {
  const location = useLocation();
  const userId = location.state?.userId || null;
  const teamId = location.state?.teamId || null;
  const filterOpen = location.state?.filterOpen;
  const defaultTeamId =
    Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : teamId;

  const [filterVisible, setFilterVisible] = useState(filterOpen || false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);

  const [leadSource, setLeadSource] = useState([]);
  const [leadSourceSearch, setLeadSourceSearch] = useState("");
  const [selectedLeadSource, setSelectedLeadSource] = useState(null);

  const [selectedLeadSourceId, setSelectedLeadSourceId] = useState(null);
  const [leadSources, setLeadSources] = useState([]);
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(userId || null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(defaultTeamId || null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startType, setStartType] = useState("text");
  const [endType, setEndType] = useState("text");
  const [searchQuery, setSearchQuery] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leadCache, setLeadCache] = useState({});
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState(null);

  const [loading, setLoading] = useState(false);
  const [teamToggle, setTeamToggle] = useState(true);



  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };

  const handleLeadInfo = (lead) => {
    let path = getBasePathByUserRole();
    navigate(`${path}/lead-info/${lead.id}`, { state: { lead } });
  };

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text, record) => (
        <div
          onClick={() => handleLeadInfo(record)}
          className="text-blue-500 text-nowrap truncate cursor-pointer"
        >
          {/* {text.replace(/\b\w/g, (char) => char.toUpperCase())} */}
          <CustomTruncatedText text={text} maxLength={35} />
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className="text-nowrap truncate">
          +{record.countryCode} {record.phoneNumber}
        </div>
      ),
    },
    {
      key: "leadSource",
      title: "Lead Source",
      render: (text) => <div>{text}</div>,
    },
    {
      key: "interestedLocations",
      title: "Location",
      render: (value) => {
        const firstLocation = value?.[0] || "No Location";
        const extraCount = value?.length > 1 ? ` +${value.length - 1}` : "";
        const fullTitle = value?.map((loc) => loc).join(", ");
        return (
          <span
            className="inline-block cursor-pointer max-w-[170px] truncate whitespace-nowrap overflow-hidden"
            title={fullTitle}
          >
            {firstLocation}
            <span className="text-blue-500">{extraCount}</span>
          </span>
        );
      },
    },
    {
      key: "assignedTeam",
      title: "Team",
      render: (value) => (
        <div title={value} className="cursor-pointer text-nowrap truncate">
          {value}
        </div>
      ),
    },
  ];

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const formattedStartDate = startDate ? formatDate(startDate) : "";
  const formattedEndDate = endDate ? formatDate(endDate) : "";

  const removalCountRef = useRef(0);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await teamService.getTeamName();
        const data = response.data?.teams || [];
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    };
    fetchTeams();
  }, []);

  useEffect(() => {
    const fetchTeamUsers = async () => {
      if (!selectedTeam) {
        setUsers([]);
        return;
      }
      setIsLoading(true);
      try {
        const selected = selectedTeam || defaultTeamId;
        const response = await teamService.getTeamData(selected);
        const data = response.data;
        const combinedUsers = [
          ...(Array.isArray(data.BOD) && data.BOD.length > 0
            ? data.BOD.map((bod) => ({ name: bod.name, id: bod.id }))
            : []),
          ...(data.MD && data.MD.name !== null && data.MD.id !== null
            ? [{ name: data.MD.name, id: data.MD.id }]
            : []),
          ...(Array.isArray(data.members) && data.members.length > 0
            ? data.members.map((member) => ({
                name: member.name,
                id: member.id,
              }))
            : []),
        ];
        setUsers(combinedUsers.length > 0 ? combinedUsers : []);
      } catch (error) {
        console.error("Error fetching team users:", error);
        setUsers([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTeamUsers();
  }, [selectedTeam, defaultTeamId]);

  const applyFilter = (removalChip) => {
    if (startDate && !endDate) {
      showErrorToast("End Date is required when Start Date is selected.");
      return;
    }
    if (teamToggle && !selectedTeam) {
      showInfoToast("Please select a team to view removals.");
      return;
    }

    const sourceId = removalChip === "source" ? null : selectedLeadSource;
    const team = removalChip === "team" ? null : selectedTeam;
    const start = removalChip === "startDate" ? null : formattedStartDate;
    const end = removalChip === "endDate" ? null : formattedEndDate;

    const noFiltersSelected = !sourceId && !team && !start && !end;
    if (teamToggle && noFiltersSelected) {
      showInfoToast("No filters selected. Please apply at least one.");
      setLeads([]);
      setHasMoreLeads(false);
      setLeadCache({});
      return;
    }

    setLeadCache({});
    handleApplyFilter(null, "reset", 10, 1, removalChip);
  };

  const handleApplyFilter = async (
    pageToken = null,
    direction = "next",
    limitOverride = null,
    overridePage = null,
    removalChip
  ) => {
    setLoading(true);
    try {
      let targetPage = overridePage ?? currentPage;
      if (direction === "next") {
        targetPage += 1;
      } else if (direction === "previous") {
        targetPage = Math.max(targetPage - 1, 1);
      } else if (direction === "reset") {
        targetPage = 1;
      }

      if (leadCache[targetPage] && !removalChip) {
        const cached = leadCache[targetPage];
        setLeads(cached.leads);
        setNextPageToken(cached.next);
        setPrevPageToken(cached.prev);
        setHasMoreLeads(!!cached.next);
        setCurrentPage(targetPage);
        setLoading(false);
        return;
      }

      const body = {
        searchKey: searchQuery || null,
        teamId: removalChip === "team" ? null : selectedTeam || defaultTeamId,
        teamStatus: teamToggle,
        leadSourceId:
          removalChip === "source" ? null : selectedLeadSource?.id ?? null,
        startDate:
          removalChip === "startDate" ? null : formattedStartDate || null,
        endDate: removalChip === "startDate" ? null : formattedEndDate || null,
        limit: limitOverride ?? pageSize,
        next: direction === "next" ? pageToken : null,
        previous: direction === "previous" ? pageToken : null,
        direction,
      };

      const filterData = await LeadDbService.leadAssign(body);
      const newLeads = filterData.data.unAssignedLeads;
      const newNext = filterData.data.next;
      const newPrev = filterData.data.prev;

      setLeadCache((prev) => ({
        ...prev,
        [targetPage]: {
          leads: newLeads,
          next: newNext,
          prev: newPrev,
        },
      }));

      setFilterVisible(false);
      setLeads(newLeads);
      setNextPageToken(newNext);
      setPrevPageToken(newPrev);
      setHasMoreLeads(!!newNext);
      setCurrentPage(targetPage);
    } catch (error) {
      console.error("Error fetching filtered leads:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (tokenOrValue, direction) => {
    if (direction === "size") {
      const newPageSize = parseInt(tokenOrValue, 10);
      setPageSize(newPageSize);
      setCurrentPage(1);
      setLeadCache({});
      setNextPageToken(null);
      setPrevPageToken(null);
      handleApplyFilter(null, "reset", newPageSize, 1);
    } else if (direction === "next") {
      setCurrentPage((prev) => prev + 1);
      handleApplyFilter(nextPageToken, "next");
    } else if (direction === "previous") {
      setCurrentPage((prev) => Math.max(prev - 1, 1));
      handleApplyFilter(prevPageToken, "previous");
    }
  };

  const clearFilterData = () => {
    return new Promise((resolve) => {
      setSelectedStatus("");
      setSelectedLevel(null);
      setLeadSource(null);
      setSelectedLeadSourceId(null);
      setLeadSourceSearch("");
      setSelectedLeadSource(null);
      setSelectedTeam("");
      setSelectedUser("");
      setStartDate("");
      setEndDate("");
      setErrors({});
      resolve();
    });
  };

  const handleClearAndApplyFilter = async () => {
    await clearFilterData();
    applyFilter();
    setLeadSourceSearch("");
    setSelectedLeadSource("");
  };

  const handleSelectionChange = (selectedIds) => {
    setSelectedRows(selectedIds);
  };

  const handleFilterLeads = () => {
    setFilterVisible(true);
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e);
  };

  const handleSelectChange = (selectedOption) => {
    setSelectedLevel(selectedOption);
  };

  const handleLeadSourceChange = (selectedOption) => {
    setLeadSource(selectedOption);
    setSelectedLeadSourceId(selectedOption ? selectedOption.value : null);
  };

  const handleTeamChange = (value) => {
    setSelectedTeam(value);
    setSelectedUser("");
  };

  const handleSearchLead = () => {
    setLeadCache({});

    const level = selectedLevel;
    const status = selectedStatus;
    const leadSource = selectedLeadSourceId;
    const team = selectedTeam;
    const user = selectedUser;
    const start = formattedStartDate;
    const end = formattedEndDate;

    const noFiltersSelected =
      (!leadSource || leadSource.length === 0) &&
      !team &&
      !start &&
      !end &&
      teamToggle;

    if (searchQuery.trim() !== "" || !noFiltersSelected) {
      handleApplyFilter();
    }
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaChevronDown className="text-customGreen" />
      </components.DropdownIndicator>
    );
  };

  const getLocalDate = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  const path = getBasePathByUserRole();

  const handleRemoveSource = () => {
    setLeadSource(null);
    setSelectedLeadSource(null);
    setLeadSourceSearch("");
    applyFilter("source");
  };

  const handleRemoveTeam = () => {
    setSelectedTeam(null);
    setSelectedUser(null);
    applyFilter("team");
  };

  const handleRemoveDate = () => {
    setStartDate(null);
    setEndDate(null);
    applyFilter("startDate");
  };

  const handleAssignTeam = () => {
    if (selectedRows.length > 300) {
      showInfoToast("You can't assign more than 300 leads at a time");
      return;
    }
    navigate(`${path}/lead/reassign`, {
      state: {
        leadSourceId: selectedLeadSourceId,
        assignStatus: true,
        teamId: selectedTeam,
        leadCount: selectedRows.length,
        leadIds: selectedRows,
        teamStatus: teamToggle,
      },
    });
  };

  const handleAllAssignLeads = async () => {
    if (teamToggle && !selectedTeams?.value) {
      showInfoToast("Please select a team to assign leads");
      return;
    }

    const body = {
      teamStatus: teamToggle,
      teamId: selectedTeams?.value,
    };

    try {
      setLoading(true);
      const response = await LeadDbService.getUnAssignedCount(body);

      console.log(response.data);
      if (response.status === 200) {
        setLoading(false);
        if (response.data?.unAssignedCount === 0) {
          showInfoToast("No leads found to assign");
          return;
        }
        navigate(`${path}/lead/reassign`, {
          state: {
            leadCount: response.data?.unAssignedCount,
            teamId: selectedTeams?.value,
            teamStatus: teamToggle,
            assignStatus: true,
            bulkAssignLead: true,
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRemove = (filterKey) => {
    console.log("Removing filter for key:", filterKey);
    switch (filterKey) {
      case "team":
        setSelectedTeam(null);
        setSelectedUser(null);
        break;

      case "source":
        setSelectedLeadSource(null);
        setLeadSourceSearch("");
        break;
      case "startDate":
        setStartDate(null);
        setEndDate(null);
        break;
      default:
        return;
    }

    applyFilter(filterKey);
  };

  const fetchLeadSourceData = async () => {
    try {
      const response = await leadSourceService.getLeadSource(leadSourceSearch);
      console.log(response.data);
      setLeadSource(response.data);
    } catch (error) {
      console.log(error);
      setLeadSource([]);
    }
  };
  useEffect(() => {
    fetchLeadSourceData();
  }, [leadSourceSearch]);

  return (
    <div className="pt-14 bg-appGrayBackground">
      <AdminAppBar />
      <ToastContainer />
      <div className="mt-[50px] px-6">
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-5">
              <CustomHeading title={"Unassign Leads"} isIcon={true} />
            </div>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-5">
                {selectedLeadSource && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                    <span>{selectedLeadSource.label}</span>
                    <button onClick={() => handleRemove("source")}>✖</button>
                  </div>
                )}
                {userRole !== "BOD" && selectedTeam && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                    <span>
                      {teams.find((team) => team.teamId === selectedTeam)
                        ?.name || selectedTeam}
                    </span>
                    <button onClick={() => handleRemove("team")}>✖</button>
                  </div>
                )}
                {(startDate || endDate) && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                    <span>
                      
                                      {`Date: ${formatToIndianDate(
                                        startDate
                                      )} - ${formatToIndianDate(endDate)}`}
                    </span>
                    <button onClick={() => handleRemove("startDate")}>✖</button>
                  </div>
                )}
              </div>
              <CustomButton
                onClick={() => {
                  setShowAssignModal(true);
                }}
                label={"All Leads Assign"}
              />
            </div>
          </div>
        </div>
      </div>

      <AssignLeadFilter
        visible={filterVisible}
        onHide={() => setFilterVisible(false)}
        status={status}
        selectedStatus={selectedStatus}
        handleStatusChange={handleStatusChange}
        interestLevel={interestLevel}
        selectedLevel={selectedLevel}
        handleSelectChange={handleSelectChange}
        handleLeadSourceChange={handleLeadSourceChange}
        setTeamToggle={setTeamToggle}
        teamToggle={teamToggle}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        customStyles={customStyles}
        teams={teams}
        leadSource={leadSource}
        setLeadSourceSearch={setLeadSourceSearch}
        setSelectedLeadSource={setSelectedLeadSource}
        selectedLeadSource={selectedLeadSource}
        leadSourceSearch={leadSourceSearch}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        DropdownIndicator={DropdownIndicator}
        handleTeamChange={handleTeamChange}
        errors={errors}
        users={users}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        isLoading={isLoading}
        startDate={startDate}
        setStartDate={setStartDate}
        startType={startType}
        setStartType={setStartType}
        endDate={endDate}
        setEndDate={setEndDate}
        endType={endType}
        setEndType={setEndType}
        getLocalDate={getLocalDate}
        handleApplyFilter={applyFilter}
        clearFilters={handleClearAndApplyFilter}
      />

      <div className="mt-[40px] px-6">
        <LeadTable
          data={leads}
          columns={columns}
          onPageChange={handlePageChange}
          selectedRows={selectedRows}
          onSelectionChange={handleSelectionChange}
          currentPage={currentPage}
          setSearchQuery={setSearchQuery}
          handleSearchLead={handleSearchLead}
          handleAssignTeam={handleAssignTeam}
          searchQuery={searchQuery}
          loading={loading}
          pageSize={pageSize}
          nextPageToken={nextPageToken}
          prevPageToken={prevPageToken}
          isAssign={true}
          hasMoreLeads={hasMoreLeads}
          handleFilterLeads={handleFilterLeads}
        />
      </div>
      <CustomModel
        isOpen={showAssignModal}
        isClose={() => {
          setShowAssignModal(false);
          setSelectedTeams(null);
        }}
        title={"Assign To All Leads"}
        content={
          <div className="flex flex-col py-4 gap-6 items-center w-full px-4">
            {/* Toggle Switch */}
            <div className="relative bg-slate-200 p-1 rounded-[10px] w-full max-w-[380px] flex justify-between items-center overflow-hidden">
              <div
                className="absolute top-1 bottom-1 left-1 w-[180px] bg-white rounded-[10px] shadow-md transition-transform duration-300 ease-in-out"
                style={{
                  transform: !teamToggle
                    ? "translateX(190px)"
                    : "translateX(0px)",
                }}
              ></div>

              <div
                className={`w-1/2 z-10 text-center cursor-pointer py-2 font-medium transition-colors duration-300 ${
                  teamToggle ? "text-customGreen" : "text-gray-700"
                }`}
                onClick={() => setTeamToggle(true)}
              >
                With Team
              </div>
              <div
                className={`w-1/2 z-10 text-center cursor-pointer py-2 font-medium transition-colors duration-300 ${
                  !teamToggle ? "text-customGreen" : "text-gray-700"
                }`}
                onClick={() => {
                  setTeamToggle(false);
                  setSelectedTeam(null);
                  setStartDate(null)
                  setEndDate(null);
                }}
              >
                Without Team
              </div>
            </div>

            {teamToggle && (
              <div className="relative w-full max-w-[400px]">
                <CustomSelect
                  options={teams.map((list) => ({
                    label: list.name,
                    value: list.teamId,
                  }))}
                  onChange={setSelectedTeams}
                  placeholder={"Select Team"}
                />
                {/* <select
                className={`appearance-none w-full border-2 rounded-md py-2 px-3 text-gray-700 cursor-pointer shadow-sm focus:outline-none ${
                  errors.teams ? "border-red-500" : "border-customGreen"
                }`}
                onChange={(e) => setSelectedTeamId(e.target.value)}
                value={selectedTeamId}
              >
                <option value="">Select Team</option>
                {teams.map((item, index) => (
                  <option key={index} value={item.teamId}>
                    {item.name}
                  </option>
                ))}
              </select> */}

                {/* Chevron Icon */}
                {/* <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-customGreen">
                <FaChevronDown />
              </div> */}

                {/* Validation Error */}
                {errors.teams && (
                  <p className="text-red-500 text-xs mt-1">{errors.teams}</p>
                )}
              </div>
            )}
          </div>
        }
        onConfirm={handleAllAssignLeads}
        onConfirmText={"Next"}
        loading={loading}
      />
    </div>
  );
};

export default AssignMain;
